import React, {Component} from 'react';
import moment from 'moment';

import classNames from 'classnames';
import {TEST_USER_INFO_LABELS} from '../../../constants/index';
import strings from 'utils/strings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';

const childTypeGrades = [
	'child-screening',
	'child',
	'youth-screening',
	'youth-followup',
];

const getFallbackText = (notAvailable) => notAvailable || strings.notavailable;

const isMissing = (value) =>
	typeof value === 'undefined' || value === null || value === '';

const getValueOrNotAvailable = (value, notAvailable) =>
	isMissing(value) ? getFallbackText(notAvailable) : value;

const InfoRow = (props) => {
	if (props.condition !== undefined && !props.condition) {
		return null;
	}

	const value = !isMissing(props.children) ? props.children : props.value;
	const displayValue = getValueOrNotAvailable(value, props.notAvailable);

	return (
		<p className="info__row">
			<span className="info__label">{props.name}</span>
			<span className="info__value">{displayValue}</span>
		</p>
	);
};

const InfoRowBool = (props) => {
	const value = !isMissing(props.children) ? props.children : props.value;
	const notAvailable = getFallbackText(props.notAvailable);
	const normalizedValue =
		typeof value === 'string' ? value.toLowerCase() : value;
	const valueText =
		normalizedValue === 'yes' ||
		normalizedValue === 'ja' ||
		normalizedValue === 'true' ||
		value === true
			? strings.yes
			: normalizedValue === 'no' ||
				  normalizedValue === 'nei' ||
				  normalizedValue === 'false' ||
				  value === false
				? strings.no
				: notAvailable;

	return (
		<InfoRow
			condition={props.condition}
			name={props.name}
			notAvailable={notAvailable}
		>
			{valueText}
		</InfoRow>
	);
};

const formatHighestEducation = (value, notAvailable) => {
	const values = {
		juniorHigh: strings.educationJuniorHigh,
		highSchool: strings.educationHighSchool,
		bachelor: strings.bachelor,
		master: strings.educationMaster,
		phd: strings.educationPhd,
		other: strings.genderOther,
	};

	return values[value] || getFallbackText(notAvailable);
};

const formatMeasure = (value, notAvailable) => {
	const values = {
		youthProgram: strings.measureYouthProgram,
		accompanyingMeasures: strings.measureAccompanyingMeasures,
		workPreparatoryTraining: strings.measureWorkPreparatoryTraining,
	};

	return values[value] || getFallbackText(notAvailable);
};

const formatRelativeDifficulties = (value, notAvailable) => {
	const values = {
		yes: strings.yes,
		no: strings.no,
		doesNotKnow: strings.answerDoesNotKnow,
	};

	return values[value] || getFallbackText(notAvailable);
};

const formatEducationProgram = (value, notAvailable) => {
	if (value === true) {
		return strings.vocational;
	}

	if (value === false) {
		return strings.studyPreparingProgram;
	}

	return getFallbackText(notAvailable);
};

class TestUserInfo extends Component {
	render() {
		const {testResult = {}, testReportLang, testType} = this.props;
		const testUser = testResult.testUser || {};
		const education = testUser.education || {};
		const age = testUser.age || {};
		const languageInfo = testUser.language || {};
		const readingAndWriting = testUser.readingAndWriting || {};
		const readingAndWritingDifficulties =
			readingAndWriting.difficultiesWith || {};
		const math = testUser.math || {};
		const adhd = testUser.adhd || {};
		const hasEducation = Boolean(testUser.education);
		const hasReadingAndWriting = Boolean(testUser.readingAndWriting);
		const isChildScreening = testType === 'child-screening';

		const notAvailable =
			testReportLang === 'nn'
				? strings._props.nn.notavailable
				: strings.notavailable;

		const testCompletionDate = testResult.completedAt
			? moment(testResult.completedAt, 'YYYY-MM-DD')
			: null;
		const requiredDate = moment('2022-04-23').format('YYYY-MM-DD');
		const timeDifference = testCompletionDate
			? moment(testCompletionDate).diff(requiredDate, 'days')
			: null;

		if (timeDifference > 1) {
		}

		const hasLongIntro = Boolean(testResult.anamnese);
		const isTestOwner = testResult.isTestOwner;

		const completeName =
			[testUser.firstName, testUser.lastName].filter(Boolean).join(' ') ||
			strings.hiddenname;

		const completeEmail = testUser.firstName
			? getValueOrNotAvailable(testUser.email, notAvailable)
			: '<Skjult Epost>';

		const monthString =
			testReportLang === 'nn' ? strings._props.nn.months : strings.months;

		const ageText =
			!isMissing(age.years) && !isMissing(age.months)
				? strings.formatString(
						strings.ageYearsAndMonthsShort,
						age.years,
						age.months,
						monthString
					)
				: notAvailable;
		const languageStatus =
			testUser.isForeign == 1
				? 'Norsk som andrespråk'
				: testUser.isForeign == 0
					? 'Norsk som førstespråk'
					: notAvailable;

		return (
			<div>
				<div className="lit-input-information">
					<button
						className={classNames('print-hide', {
							'lit-btn2 see-more': true,
							'bg-tertiary': true,
						})}
						onClick={() => {
							window.print();
							/* this.updatePrintLog('Results'); */
						}}
					>
						<FontAwesomeIcon
							size="lg"
							className="lit-icon-btns"
							icon={faPrint}
						/>

						<p className="lit-btns-txt">
							{strings.printInformation}
						</p>
					</button>
				</div>

				<div className="info">
					<InfoRow
						condition={isTestOwner}
						name={strings.nameColonNoSpace}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					>
						{completeName}
					</InfoRow>
					{isChildScreening && (
						<InfoRow
							condition={hasEducation && education.isInHighSchool}
							hasLongIntro={hasLongIntro}
							name={strings.gradeColonLabel}
							notAvailable={notAvailable}
						>
							{education.youthGrade}
						</InfoRow>
					)}
					<InfoRow
						name={strings.dateOfCompletion}
						value={
							testResult.completedAt
								? moment(testResult.completedAt).format('LL')
								: notAvailable
						}
						notAvailable={notAvailable}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.emailColon}
						value={completeEmail}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.telephoneColon}
						value={testUser.phone}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					/>
					<InfoRow
						name={strings.ageAtCompletion}
						value={ageText}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					/>
					<InfoRow
						name={strings.genderColon}
						value={
							testUser.gender === 'm' &&
							childTypeGrades.includes(testType)
								? strings.boy
								: testUser.gender === 'f' &&
									  childTypeGrades.includes(testType)
									? strings.girl
									: testUser.gender === 'm' &&
										  !childTypeGrades.includes(testType)
										? strings.male
										: testUser.gender === 'f' &&
											  !childTypeGrades.includes(
													testType
											  )
											? strings.female
											: notAvailable
						}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					/>
					<InfoRow
						name="Språkstatus:"
						value={languageStatus}
						hasLongIntro={hasLongIntro}
						notAvailable={notAvailable}
					/>

					{!isChildScreening && (
						<div className="info__group info__group--education">
							<h3>{strings.education}</h3>

							{hasEducation && (
								<>
									<InfoRow
										name={strings.highestEducation}
										value={formatHighestEducation(
											education.highestCompletedEducation,
											notAvailable
										)}
										notAvailable={notAvailable}
										hasLongIntro={hasLongIntro}
									/>

									{education.highestCompletedEducation ===
										'other' && (
										<InfoRow
											name={strings.otherCompetence}
											hasLongIntro={hasLongIntro}
											notAvailable={notAvailable}
										>
											{education.otherEducation}
										</InfoRow>
									)}

									<InfoRowBool
										notAvailable={notAvailable}
										name={strings.goesToHighSchool}
										value={education.isInHighSchool}
										hasLongIntro={hasLongIntro}
									/>

									{testType !== 'child-screening' && (
										<InfoRow
											condition={education.isInHighSchool}
											name={strings.educationProgramColon}
											hasLongIntro={hasLongIntro}
											notAvailable={notAvailable}
										>
											{formatEducationProgram(
												education.vocationalEducation,
												notAvailable
											)}
										</InfoRow>
									)}

									<InfoRow
										condition={education.isInHighSchool}
										hasLongIntro={hasLongIntro}
										name={strings.gradeColonLabel}
										notAvailable={notAvailable}
									>
										{testType === 'adult-screening'
											? education.grade
											: education.youthGrade ||
												testUser.class}
									</InfoRow>

									{hasEducation &&
										!education.isInHighSchool && (
											<>
												<InfoRowBool
													notAvailable={notAvailable}
													name={
														strings.onWorkAssessmentAllowanceQuestion
													}
													value={
														education.onWorkAssessmentAllowance
													}
													hasLongIntro={hasLongIntro}
												/>

												<InfoRow
													condition={
														education.onWorkAssessmentAllowance
													}
													name={strings.measureColon}
													hasLongIntro={hasLongIntro}
													notAvailable={notAvailable}
												>
													{formatMeasure(
														education.measure,
														notAvailable
													)}
												</InfoRow>

												{!education.onWorkAssessmentAllowance && (
													<>
														<InfoRowBool
															notAvailable={
																notAvailable
															}
															name={
																strings.adultEducationQuestion
															}
															value={
																education.isDoingAdultEducation
															}
															hasLongIntro={
																hasLongIntro
															}
														/>

														<InfoRowBool
															notAvailable={
																notAvailable
															}
															condition={
																!education.isDoingAdultEducation
															}
															name={
																strings.higherEducationQuestion
															}
															value={
																education.isDoingHigherEducation
															}
															hasLongIntro={
																hasLongIntro
															}
														/>
													</>
												)}
											</>
										)}
								</>
							)}
						</div>
					)}
					{/* {!isChildScreening && (
						<div>
							<div className="info__group info__group--language">
								<h3>{`Språk`}</h3>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du vansker med huske hvilket ord du skal si, når du snakker? `}
									hasLongIntro={hasLongIntro}
									value={
										languageInfo.troubleRememberingWhichWordToSay
									}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Stokker du ofte om på ordene når du prater? `}
									hasLongIntro={hasLongIntro}
									value={
										languageInfo.shufflesWordsWhenSpeaking
									}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Bruker du lang tid på å formulere deg riktig, når du snakker? `}
									hasLongIntro={hasLongIntro}
									value={
										languageInfo.spendsLongTimeFormulatingCorrectly
									}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har det noen ganger vært mistanke om at du har språkvansker? `}
									hasLongIntro={hasLongIntro}
									value={
										languageInfo.hasBeenSuspicionsOfDifficulties
									}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du vært utredet for språkvansker av PPT eller andre? `}
									value={
										languageInfo.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										languageInfo.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
									name={`Har du en diagnose, f.eks. spesifikke språkvansker? `}
									value={languageInfo.hasDiagnosis}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										!languageInfo.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
									name={`Mistenker du selv at du har språkvansker? `}
									value={
										languageInfo.suspectsToHaveDifficulties
									}
								/>

								<InfoRow
									name={`Har noen i din nærmeste familie (slektninger) språkvansker? `}
									value={formatRelativeDifficulties(
										languageInfo.closeRelativeHasDifficulties,
										notAvailable
									)}
									notAvailable={notAvailable}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={`Hvordan vil du rangere dine egne muntlige språkferdigheter på en skala fra 1-6, hvor
                        1 er svært dårlig og 6 er svært bra? `}
									value={languageInfo.selfRating}
									hasLongIntro={hasLongIntro}
									notAvailable={notAvailable}
								/>
							</div>
						</div>
					)} */}
					{hasReadingAndWriting && isChildScreening && (
						<div className="info__group info__group--reading-and-writing">
							<h3>{strings.readingAndWritingHeading}</h3>
							<p className="indent"></p>

							<InfoRowBool
								notAvailable={notAvailable}
								name={
									strings.childDiagnosedReadingWritingQuestion
								}
								value={
									readingAndWriting.hasBeenAssessedForDifficulties
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={
									strings.childSuspectedReadingWritingQuestion
								}
								value={readingAndWriting.suspectsToHaveDyslexia}
								hasLongIntro={hasLongIntro}
							/>
						</div>
					)}
					{hasReadingAndWriting && !isChildScreening && (
						<div className="info__group info__group--reading-and-writing">
							<h3>{strings.readingAndWritingHeading}</h3>
							<p className="indent">
								<strong>{strings.difficultiesWithIntro}</strong>
							</p>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyReadWordsCorrectly}
								value={
									readingAndWritingDifficulties.readingWordsCorrectly
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyReadLongTexts}
								value={
									readingAndWritingDifficulties.readLongTexts
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyRememberWhatRead}
								value={
									readingAndWritingDifficulties.rememberingWhatYouHaveRead
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyWriteWordsCorrectly}
								value={
									readingAndWritingDifficulties.writeWordsProperly
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyGetThoughtsOnPaper}
								value={
									readingAndWritingDifficulties.gettingThoughtsOntoPaper
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.difficultyReadWriteEnglish}
								value={
									readingAndWritingDifficulties.readingAndWritingEnglish
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.assessedReadingWritingQuestion}
								value={
									readingAndWriting.hasBeenAssessedForDifficulties
								}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								condition={
									readingAndWriting.hasBeenAssessedForDifficulties
								}
								name={strings.hasDyslexiaDiagnosisQuestion}
								value={readingAndWriting.hasDiagnosis}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRowBool
								notAvailable={notAvailable}
								condition={
									!readingAndWriting.hasBeenAssessedForDifficulties
								}
								name={strings.suspectsDyslexiaQuestion}
								value={readingAndWriting.suspectsToHaveDyslexia}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRow
								name={
									strings.familyReadingWritingDyslexiaQuestion
								}
								value={formatRelativeDifficulties(
									readingAndWriting.closeRelativeHasDifficulties,
									notAvailable
								)}
								notAvailable={notAvailable}
								hasLongIntro={hasLongIntro}
							/>

							<InfoRow
								name={strings.rateReadingWritingSkillsQuestion}
								value={readingAndWriting.selfRating}
								hasLongIntro={hasLongIntro}
								notAvailable={notAvailable}
							/>
						</div>
					)}
					{/* {!isChildScreening && (
						<div>
							<div className="info__group info__group--math">
								<h3>{`Matematikk`}</h3>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du vansker med regning eller matematikk? `}
									value={
										math.hasDifficultiesWithMathOrCalculation
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du vært utredet for matematikkvansker av PPT eller andre? `}
									value={math.hasBeenAssessedForDifficulties}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										math.hasBeenAssessedForDifficulties
									}
									name={`Har du en diagnose (f.eks. dyskalkuli eller spesifikke matematikkvansker)? `}
									value={math.hasDiagnosis}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										!math.hasBeenAssessedForDifficulties
									}
									name={`Mistenker du selv at du har dyskalkuli? `}
									value={math.suspectsToHaveDyscalculia}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={`Har noen i din nærmeste familie (slektninger) mattevansker eller dyskalkuli? `}
									value={formatRelativeDifficulties(
										math.closeRelativeHasDifficulties,
										notAvailable
									)}
									notAvailable={notAvailable}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={`Hvordan vil du rangere dine egne matematikkferdigheter på en skala fra 1-6, hvor 1
                        er svært dårlig og 6 er svært bra? `}
									value={math.selfRating}
									hasLongIntro={hasLongIntro}
									notAvailable={notAvailable}
								/>
							</div>

							<div className="info__group info__group--adhd">
								<h3>{`Konsentrasjon`}</h3>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du problemer med konsentrasjon og utholdenhet? `}
									value={
										adhd.hasDifficultiesWithConcentrationAndStamina
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Kjeder du deg lett og blir rastløs? `}
									value={adhd.easilyBoredAndRestless}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									name={`Har du vært utredet for ADD eller ADHD? `}
									value={adhd.hasBeenAssessedForDifficulties}
									hasLongIntro={hasLongIntro}
								/>

								{adhd.hasBeenAssessedForDifficulties && (
									<InfoRowBool
										notAvailable={notAvailable}
										name={`Har du en diagnose (f.eks. ADD eller ADHD)? `}
										value={adhd.hasDiagnosis}
										hasLongIntro={hasLongIntro}
									/>
								)}

								{!adhd.hasBeenAssessedForDifficulties && (
									<InfoRowBool
										notAvailable={notAvailable}
										name={`Mistenker du selv at du har ADD eller ADHD? `}
										value={adhd.suspectsToHaveAddOrAdhd}
										hasLongIntro={hasLongIntro}
									/>
								)}

								<InfoRow
									name={`Har noen i din nærmeste familie (slektninger) diagnosen ADD eller ADHD? `}
									value={formatRelativeDifficulties(
										adhd.closeRelativeHasDifficulties,
										notAvailable
									)}
									notAvailable={notAvailable}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={`Hvordan vil du rangere din generelle konsentrasjonsevne på en skala fra 1-6, hvor 1
                        er svært dårlig og 6 er svært bra? `}
									value={adhd.selfRating}
									hasLongIntro={hasLongIntro}
									notAvailable={notAvailable}
								/>
							</div>
						</div>
					)} */}
				</div>
			</div>
		);
	}
}

export default TestUserInfo;
